import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  toggleSubStep,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * サブステップの完了状態をトグルする mutation hook。
 * optimistic update なし（シンプル実装）。
 * onSuccess で detail + list query を invalidate する。
 */
export function useToggleSubStep(
  caseId: string,
): InvalidatingMutationResultFor<typeof toggleSubStep> {
  return useInvalidatingMutation(toggleSubStep, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    // サブステップの完了状態が変わると status (= progress) も変わるため list も invalidate
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
